import Vue from "vue";

//Notification state: vuex store module
const initialState = {
    NotificationModals: {
        Success: false,
        OpenState: false,
        Message: ""
    }
};

const state = JSON.parse(JSON.stringify(initialState));

const actions = {};

const mutations = {
    changeNotificationModalState(state, payload) {
        var group = "topCenter";

        if (payload.position) {
            group = payload.position;
        }

        if (payload.type.toLowerCase() == "success") {
            Vue.notify({
                title: "Success",
                text: payload.message,
                type: "success",
                //YOU MUST call the notification module with group=default
                //inside the App.vue file
                group: group
            });
        } else {
            Vue.notify({
                title: "Error",
                text: payload.message,
                type: "error",
                group: group
            });
        }
    }
};

const getters = {
    getOpenState: state => {
        return state.NotificationModals.OpenState;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
